import React, { Component } from 'react';
import HeaderLine from '../../../components/HeaderLine';
import CardEspecialProperties from './Cards';
import Button from '../../../components/Button';
import Utils from '../../../helpers/Utils';
import Loader from './Loader';
import Services from './Services';
import imoveisVenda from './../../../assets/images/cards/imoveisParaVenda.jpg'
import './styles.css';

export default class EspecialProperties extends Component {
    state = {
        destaques: []
    }

    constructor(props) {
        super(props);
        this._services = new Services();
    }

    componentDidMount(){
        this.handleEspecialProperties();
    }

    handleEspecialProperties = () => {
        this.setState({
            destaques: [
                {
                    "id": 3,
                    "highlight": "casas em condomínio",
                    "label": "O melhor em ",
                    "image": "https://api.estafor.com.br/lib/images/cards/casa-em-condominio01.jpg"
                },
                {
                    "id": 4,
                    "highlight": "imóveis comerciais",
                    "label": "Seu negócio nos principais",
                    "image": "https://api.estafor.com.br/lib/images/cards/ponto-comercial.jpg"
                },
                {
                    "id": 105,
                    "highlight": "ofertas imperdíveis",
                    "label": "Ofertas",
                    "image": "https://api.estafor.com.br/lib/images/cards/primeiraLocacao.jpg"
                }
            ]
        });
    }

    render() {
        return (
            <section id="especial-properties-section">
                <div className="container">
                    <HeaderLine label="Imóveis especiais para você" />
                    {this.state.destaques.length > 0 ? 
                        <div id="especial-properties-box">                        
                            { this.state.destaques.map((item, index) => {
                                return (
                                    <CardEspecialProperties
                                        key={index}
                                        to={`/aluguel/destaque-especial/${Utils.transliterate(item.highlight)}`}
                                        image={item.image} label={item.label} highlight={item.highlight}
                                    />
                                );
                            })}

                            <CardEspecialProperties 
                                to={`/busca/venda/apartamento/fortaleza/residencial`}
                                image={imoveisVenda} label="Conheça nossos" highlight="destaques para venda"
                            />
                        </div>
                    : <Loader/>}

                    <Button 
                        to='/busca/aluguel/apartamento/fortaleza/residencial'
                        label="Ver todos os imóveis"
                        color="primary"
                        icon="fas fa-chevron-right" 
                    />
                </div>
            </section>
        );
    }
}

